export const A11Y_CONTENT_SUFFIX = 'comment-content';
